import React from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  sidebarAction
} from "../../redux/reducer/SidebarSlice";


const AfterLoginTopbar = (props) => {

  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarReducer)

  let navigate = useNavigate();
  
  return (
    <div className='login-after-top'>
      <div className='login-after-top-left'>
        {props.acttion == "menu" ? 
        <button
        onClick={() =>
          dispatch(sidebarAction(sidebarShow)) 
        }
      >
    <i className="fa-solid fa-bars"></i>
</button>
:
props.acttion == "back" ? 
<button className='back-btn' onClick={() => navigate(-1)}>
            <i className="fa-solid fa-arrow-left"></i>
        </button>
:
null
      }
          
          <h3>{props.title}</h3>
        </div>
        <div className='login-after-top-right'>
              <NavLink>
              <i className="fa-solid fa-bell"></i>
              </NavLink>
        </div>
    </div>
  )
}

export default AfterLoginTopbar